module.exports = __webpack_public_path__ + "media/images/icons/tick-green-circle-67b8e24a72d525023623fc03024f288b.svg";